import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAssetTrendDataByTags } from '../../services/dashboard/AssetTrendDataService';

const initialState: {
  data: any[] | undefined;
  loading: boolean;
  error: any | undefined;
  rawData: any[] | undefined;
  startDate: Date | null;
  endDate: Date | null;
  aggregate: string | null;
  paramStdTypes: (string | number)[];
} = {
  data: undefined,
  loading: false,
  error: undefined,
  rawData: undefined,
  startDate: null,
  endDate: null,
  aggregate: null,
  paramStdTypes: [],
};

const AssetTrendDataByTagsSlice = createSlice({
  name: 'assetTrendDataByTagsSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.rawData = undefined;
      state.error = undefined;
      state.loading = false;
      state.startDate = null;
      state.endDate = null;
      state.aggregate = null;
      state.paramStdTypes = [];
    },
    setDateRangeAndAggregate: (state, action) => {
      const { startDate, endDate, aggregate } = action.payload;
      state.startDate = startDate;
      state.endDate = endDate;
      state.aggregate = aggregate;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssetTrendByTagsStateAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssetTrendByTagsStateAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchAssetTrendByTagsStateAsync.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Async thunk to fetch the initial state data
export const fetchAssetTrendByTagsStateAsync = createAsyncThunk(
  'assetTrendDataByTagsSlice/fetchInitialState',
  async ({
    assetId,
    startDate,
    endDate,
    aggregate,
    aggregateMethod,
    paramStdTypes,
  }: {
    assetId: string;
    startDate: Date;
    endDate: Date;
    aggregate: string;
    aggregateMethod: string;
    paramStdTypes: (string | number)[];
  }) => {
    const response = await fetchAssetTrendDataByTags(
      assetId,
      startDate,
      endDate,
      aggregate,
      aggregateMethod,
      paramStdTypes,
    );
    return response;
  },
);

export const { setInitialState, setDateRangeAndAggregate } = AssetTrendDataByTagsSlice.actions;

export default AssetTrendDataByTagsSlice.reducer;
